// Template252: Bélgica - Día 3 Gante continuación (Page10.jsx)
// Gravensteen, Iglesia San Nicolás (sticker castillo), Puente San Miguel, Werregarenstraat, tip grafiti + texto, imagen inferior.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template252 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const gravenTitle = page?.texts?.[1]?.content;
	const gravenBody = page?.texts?.[2]?.content;
	const sanNicolasTitle = page?.texts?.[3]?.content;
	const sanNicolasBody = page?.texts?.[4]?.content;
	const puenteTitle = page?.texts?.[5]?.content;
	const puenteBody = page?.texts?.[6]?.content;
	const werreTitle = page?.texts?.[7]?.content;
	const werreBody = page?.texts?.[8]?.content;
	const tipGrafiti = page?.texts?.[9]?.content;
	const textoExtra = page?.texts?.[10]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const img1 = getImageSrc("img1");
	const img2Sticker = getImageSrc("img2-sticker");
	const img2 = getImageSrc("img2");
	const img3 = getImageSrc("img3");
	const stickerGrafiti =
		getImageSrc("sticker") || getImageSrc("sticker-grafiti");
	const portadaImage = getImageSrc("portada");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#D4A017";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
		marginBottom: "4px",
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 9999,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					flex: 1,
					display: "flex",
					flexDirection: "column",
					gap: 1.5,
				}}
			>
				{/* Castillo Gravensteen */}
				{(gravenTitle || gravenBody) && (
					<Box
						data-block-id="text-2"
						sx={{
							display: "flex",
							gap: 2.5,
							alignItems: "flex-start",
							position: "relative",
						}}
					>
						{img1 && (
							<Box
								component="img"
								src={img1}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									borderRadius: "12px",
									objectFit: "cover",
								}}
							/>
						)}
						{sabiasQue[0] && (
							<Box sx={{ position: "absolute", top: 10, left: "35%" }}>
								<SabiasQue
									icono={sabiasQue[0].icono}
									texto={sabiasQue[0].texto}
								/>
							</Box>
						)}
						<Box sx={{ width: "60%", position: "relative" }}>
							{gravenTitle && (
								<Box component="h3" sx={estiloH3}>
									{gravenTitle}
								</Box>
							)}
							{gravenBody && (
								<Box component="p" sx={estiloP}>
									{gravenBody}
								</Box>
							)}
						</Box>
					</Box>
				)}

				{/* Iglesia San Nicolás */}
				{(sanNicolasTitle || sanNicolasBody) && (
					<Box
						data-block-id="text-3"
						sx={{
							display: "flex",
							gap: 2,
							position: "relative",
							marginTop: isSmallScreen ? 3 : 0,
						}}
					>
						<Box sx={{ width: "100%", position: "relative" }}>
							{img2Sticker && (
								<Box
									component="img"
									src={img2Sticker}
									alt=""
									sx={{
										width: isSmallScreen ? 90 : 105,
										position: "absolute",
										top: isSmallScreen ? -40 : -60,
										right: isSmallScreen ? -30 : -20,
									}}
								/>
							)}
							{sabiasQue[1] && (
								<Box
									sx={{
										position: "absolute",
										top: isSmallScreen ? -20 : 0,
										right: "35%",
									}}
								>
									<SabiasQue
										icono={sabiasQue[1].icono}
										texto={sabiasQue[1].texto}
									/>
								</Box>
							)}
							<Box
								sx={{
									padding: "20px",
									backgroundColor: "#f9ebc8",
									borderRadius: "12px",
									fontSize: 13,
									color: "#000",
								}}
							>
								{sanNicolasTitle && (
									<Box component="h3" sx={estiloH3}>
										{sanNicolasTitle}
									</Box>
								)}
								{sanNicolasBody && (
									<Box component="span" sx={estiloP}>
										{sanNicolasBody}
									</Box>
								)}
							</Box>
						</Box>
					</Box>
				)}

				{/* Puente San Miguel */}
				{(puenteTitle || puenteBody) && (
					<Box
						data-block-id="text-4"
						sx={{
							display: "flex",
							gap: 2.5,
							alignItems: "flex-start",
							position: "relative",
						}}
					>
						{img2 && (
							<Box
								component="img"
								src={img2}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									borderRadius: "12px",
									objectFit: "cover",
								}}
							/>
						)}
						{sabiasQue[2] && (
							<Box sx={{ position: "absolute", top: 0, left: "35%" }}>
								<SabiasQue
									icono={sabiasQue[2].icono}
									texto={sabiasQue[2].texto}
								/>
							</Box>
						)}
						<Box sx={{ width: "60%", position: "relative" }}>
							{puenteTitle && (
								<Box component="h3" sx={estiloH3}>
									{puenteTitle}
								</Box>
							)}
							{puenteBody && (
								<Box component="p" sx={estiloP}>
									{puenteBody}
								</Box>
							)}
						</Box>
					</Box>
				)}

				{/* Werregarenstraat */}
				{(werreTitle || werreBody) && (
					<Box data-block-id="text-5" sx={{ display: "flex", gap: 2.5, alignItems: "flex-start" }}>
						{img3 && (
							<Box
								component="img"
								src={img3}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									borderRadius: "12px",
									objectFit: "cover",
								}}
							/>
						)}
						<Box sx={{ width: "60%" }}>
							{werreTitle && (
								<Box component="h3" sx={estiloH3}>
									{werreTitle}
								</Box>
							)}
							{werreBody && (
								<Box component="p" sx={estiloP}>
									{werreBody}
								</Box>
							)}
						</Box>
					</Box>
				)}

				{/* Caja tip grafiti + texto */}
				{(tipGrafiti || textoExtra) && (
					<Box
						data-block-id="text-6"
						sx={{
							display: "flex",
							gap: 2,
							position: "relative",
							backgroundColor: "#f9ebc8",
						}}
					>
						{tipGrafiti && (
							<Box
								sx={{
									position: "absolute",
									bottom: isSmallScreen ? -70 : 40,
									right: 0,
									backgroundColor: "#fff8db",
									border: "2px solid #D4A017",
									borderRadius: "16px 16px 0px 16px",
									padding: "10px 12px",
									fontSize: "11px",
									color: "#444",
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: isSmallScreen ? 200 : 140,
									zIndex: 6,
								}}
							>
								{tipGrafiti}
							</Box>
						)}
						{stickerGrafiti && (
							<Box
								component="img"
								src={stickerGrafiti}
								alt=""
								sx={{
									width: 105,
									position: "absolute",
									bottom: isSmallScreen ? -150 : -40,
									right: -20,
								}}
							/>
						)}
						<Box sx={{ width: "100%", position: "relative" }}>
							{textoExtra && (
								<Box
									component="p"
									sx={{
										...estiloP,
										padding: "20px",
										borderRadius: "12px",
										width: isSmallScreen ? "100%" : "75%",
									}}
								>
									{textoExtra}
								</Box>
							)}
						</Box>
					</Box>
				)}
			</Box>

			{/* Imagen inferior */}
			{portadaImage && (
				<Box sx={{ marginTop: "auto" }}>
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{
							width: "100%",
							height: isSmallScreen ? 200 : 100,
							objectFit: "cover",
						}}
					/>
				</Box>
			)}
		</Box>
	);
};

Template252.thumbnail = "/images/template-1.png";
export default Template252;
